import React, { lazy } from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import { Approvals, Calender, Regularization, AttendanceMuster, ReportProcess, EmployeeTracker, OnsiteApprovals } from "@/pages/attendance/views";
import AdminAttendanceRegApproved from "@/pages/attendance/views/adminAttendanceRegApproved/AdminAttendanceRegApproved";
const attendanceRoutes = [
  {
    path: "attendance/calendar",
    element: (
      <SuspenseWrapper>
        <Calender />
      </SuspenseWrapper>
    ),
  },
  {
    path: "attendance/regularization",
    element: (
      <SuspenseWrapper>
        <Regularization />
      </SuspenseWrapper>
    ),
  },
  {
    path: "attendance/approvals",
    element: (
      <SuspenseWrapper>
        <Approvals />
      </SuspenseWrapper>
    ),
  },
  {
    path: "attendance/attendanceMuster",
    element: (
      <SuspenseWrapper>
        <AttendanceMuster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "attendance/adminAttendanceRegApproved",
    element: (
      <SuspenseWrapper>
        <AdminAttendanceRegApproved />
      </SuspenseWrapper>
    ),
  },
   {
    path: "/attendance/report",
    element: (
      <SuspenseWrapper>
        <ReportProcess />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/attendance/employeeTracker",
    element: (
      <SuspenseWrapper>
        <EmployeeTracker />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/attendance/onsiteApprovals",
    element: (
      <SuspenseWrapper>
        <OnsiteApprovals />
      </SuspenseWrapper>
    ),
  },
];

export default attendanceRoutes;
